import { render } from "./PhotoGallery.vue?vue&type=template&id=138b2d3c"
import script from "./PhotoGallery.vue?vue&type=script&lang=js"
export * from "./PhotoGallery.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__